var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import TextInput from './TextInput';
function OutlineTextInput(props) {
    return (_jsx(TextInput, __assign({}, props, { className: "rounded-md shadow-sm border-gray-300 focus:ring-indigo-500 focus:border-indigo-500" }), void 0));
}
export default OutlineTextInput;
